import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Crown } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";
import { NAV } from "../data/site";

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-gold/30 bg-onyx/95 backdrop-blur-md" data-testid="navbar">
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-4 py-3 sm:px-6">
        <Link to="/" className="flex items-center gap-2.5" data-testid="nav-logo" onClick={() => setOpen(false)}>
          <Crown className="h-6 w-6 text-gold" strokeWidth={1.5} />
          <span className="font-display text-xl uppercase leading-none tracking-wide text-metallic sm:text-2xl">
            Big Little Village
          </span>
        </Link>

        <nav className="hidden items-center gap-1 lg:flex">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`nav-${item.to.replace("/", "")}`}
              className={({ isActive }) =>
                `px-3 py-2 font-head text-xs font-bold uppercase tracking-[0.18em] transition-colors ${
                  isActive ? "text-goldlight" : "text-silver/80 hover:text-cream"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/apply"
            data-testid="nav-apply-btn"
            className="hidden border border-gold bg-gradient-to-b from-goldlight to-gold px-5 py-2 font-head text-xs font-extrabold uppercase tracking-[0.18em] text-onyx transition-transform duration-200 hover:-translate-y-0.5 sm:inline-flex"
          >
            Join the Cohort
          </Link>
          <button
            className="border border-silver/40 p-2 text-cream lg:hidden"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
            data-testid="nav-menu-toggle"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.25 }}
            className="overflow-hidden border-t border-gold/25 bg-onyx lg:hidden"
            data-testid="mobile-menu"
          >
            <div className="flex flex-col p-4">
              {NAV.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) =>
                    `border-b border-gold/15 py-3 font-head text-base font-bold uppercase tracking-[0.15em] ${
                      isActive ? "text-goldlight" : "text-silver"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
              <Link
                to="/apply"
                onClick={() => setOpen(false)}
                className="mt-4 border border-gold bg-gradient-to-b from-goldlight to-gold px-5 py-3 text-center font-head text-sm font-extrabold uppercase tracking-[0.18em] text-onyx"
              >
                Join the Cohort
              </Link>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
